import PersonalIcon from '../images/personal-icon.svg';
import BetaJoin from '../images/beta-join.png';

const metadata = {
  default: {
    title: 'Trova | Cross-Platform Personal Search',
    description: 'Trova is an AI-driven unified personal search platform that finds your scattered information across different workspaces. Our goal is to elevate your productivity in one search. No more head-scratching on where your content is. Trova is here to transform the way digital conversations are organized and accessed.',
    image: PersonalIcon,
  },
  about: {
    title: 'Trova | Cross-Platform Personal Search',
    description: 'Trova is an AI-driven unified personal search platform that finds your scattered information across different workspaces. Our goal is to elevate your productivity in one search. No more head-scratching on where your content is. Trova is here to transform the way digital conversations are organized and accessed.',
    image: PersonalIcon,
  },
  searchportal: {
    title: 'Search Portal | Trova',
    description: 'Trova is a unified personal search engine that uses AI and NLP to find your scattered information across different Cloud apps (like Gmail, Slack, Teams, Jira, etc.,) as quickly and effectively as your personal assistant -- just Trova it.',
    image: BetaJoin,
  },
  publicbeta: {
    title: 'Beta Sign Up | Trova',
    description: 'Sign up to Trova’s Public Beta to find your scattered information quickly and efficiently. Trova is building a unified personal search engine that thinks like you and boosts your productivity.',
    image: BetaJoin,
  },
  signin: {
    title: 'Sign In | Trova',
    description: 'Sign in to Trova using Google Accounts to find your scattered information quickly and efficiently. Trova is building a unified personal search engine that thinks like you and boosts your productivity.',
    image: PersonalIcon,
  },
  howitworks: {
    title: 'How Trova Works',
    description: 'Trova is a unified personal search engine that uses AI and NLP to find your scattered information across different Cloud apps (like Gmail, Slack, Teams, Jira, etc.,) as quickly and effectively as your personal assistant -- just Trova it.',
    image: PersonalIcon,
  },
  careers: {
    title: 'Careers | Trova',
    description: 'Find a job at Trova! ​​We are passionate about technology and innovation that focuses on the real people who will be using it.',
    image: BetaJoin,
  },
  aboutus: {
    title: 'About Us | Trova',
    description: 'Trova is a young startup with a team of exceptional and fun individuals dedicated to things we are enthusiastic about. The teams’ cross-functional skills complement each other to create an impactful solution that increases productivity and makes users’ lives easier.',
    image: BetaJoin,
  },
  privacy: {
    title: 'Privacy Policy | Trova',
    description: 'Trova is committed to creating a secure space for our users and your privacy matters to us. Trova does not and will not sell Your Data, individually or in aggregated form.',
  },
  tos: {
    title: 'Terms of Service | Trova',
    description: 'We know it’s tempting to skip these Terms of Service, but it’s important to establish what you can expect from us as you use Trova services, and what we expect from you.',
  },
  security: {
    title: 'Security practices | Trova',
    description: 'Data protection comes first. We take your data security as our priority at Trova. We aim to be transparent and open about handling data security to build mutual trust with our users.',
  }
}

export default metadata;